<template>
<div id="newsletter-types">
  <h2>Newsletter Types</h2>

  <newsletter-type-nav />

  <pagination
    :resourceUrl="this.apiUrl('/newsletter_types', true)"
    orderBy="name"
    orderType="ASC"
  >
    <template
      slot="pagination_hdr"
    >
    </template>
    <template
      slot="paged_item"
      slot-scope="item"
    >
      <router-link
        :class="$root.listItemClasses"
        :to="{ name: 'newsletter_type', params: { newsletterTypeId: item.id }}"
      >
        {{ item.name }}
        <span
          class="badge badge-sm badge-primary"
          v-if="item.requires_subscription"
        >Subscribers Only</span>
        <span
          class="badge badge-sm badge-info"
          v-if="item.parent_newsletter_type_id"
        >Subtype</span>
        <span
          class="badge badge-sm badge-secondary"
          v-if="item.digest"
        >Digest</span>
        <span
          class="badge badge-sm badge-warning"
          v-if="!item.visible"
        >Hidden</span>
        <span
          class="badge badge-sm badge-info"
          v-if="!item.is_public"
        >Private</span>
        <span
          class="badge badge-sm badge-danger"
          v-if="item.inactive"
        >Inactive</span>
      </router-link>
    </template>
  </pagination>
</div>
</template>

<script>
import NewsletterTypeNav from '@/components/NewsletterTypeNav'

import NewsletterTypesStore from '@/stores/NewsletterTypesStore'

import Pagination from 'sai-vue-kaminari'

export default {
  data () {
    return NewsletterTypesStore.state
  },

  components: {
    'newsletter-type-nav': NewsletterTypeNav,
    pagination: Pagination
  },

  onPageSuccess (response) {
    this.newsletter_types = this.processSuccess(response)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewsletterTypes.vue